import { Link } from "react-router-dom";
import { useCatalog, findBottle, pricePerLitre } from "@/lib/shop";
import Jar from "@/components/visual/Jar";
import AddToBasket from "./AddToBasket";

/** "The jar we suggest for this" card used inside guides. */
export default function BestBottle({ bestFor, why, keyword }) {
  const products = useCatalog();
  const match = findBottle(products, bestFor);
  if (!match?.variant) return null;
  const { product, variant } = match;
  const ppl = pricePerLitre(variant);
  return (
    <div className="not-prose my-8 rounded-3xl bg-white p-5 sm:p-6 flex items-center gap-5 shadow-[0_20px_40px_-28px_rgba(0,0,0,0.35)]" data-testid="best-bottle">
      <div className="h-24 w-16 shrink-0 rounded-2xl bg-brand-obsidian flex items-center justify-center">
        <Jar className="h-[82%] w-auto" label={false} title={product.name} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-body text-[12px] font-semibold text-brand-gold">Our pick {keyword ? `for ${keyword.replace(/^coconut oil (for |as )?/, "")}` : ""}</p>
        <Link to={`/products/${product.slug}`} className="block font-display text-[19px] leading-tight text-brand-ink hover:underline">
          {product.name}, {variant.size}
        </Link>
        {why && <p className="mt-1 font-body text-[14px] leading-snug text-ink-muted">{why}</p>}
        <p className="mt-1 font-body text-[14px] text-brand-ink">
          ₹{variant.price}{ppl ? <span className="text-ink-muted"> · ₹{ppl} a litre</span> : null}
        </p>
      </div>
      <AddToBasket product={product} variant={variant} label="Add" className="h-10 px-5 text-[14px] shrink-0" testid="best-bottle-add" />
    </div>
  );
}
